// extracted by mini-css-extract-plugin
export default {"case-table-container":"styles_case-table-container__yKB7v","case-table-header":"styles_case-table-header__YUi78"};